// extracted by mini-css-extract-plugin
module.exports = {"head":"TableCarField_head_2Oy9w","item":"TableCarField_item_3_BhI","row":"TableCarField_row_15xdx","col":"TableCarField_col_1ZgkP","footer":"TableCarField_footer_1447A"};